import React from 'react';
import { Modal } from 'react-bootstrap';

const AddUserModal = ({ show, onHide, onSave, userData, setUserData, loading }) => {
  const handleChange = (e) => {
    setUserData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Добавить нового пользователя</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="form-group">
          <div className="mb-3">
            <label htmlFor="name">Имя</label>
            <input
              id="name"
              type="text"
              className="form-control"
              name="name"
              value={userData.name || ''}
              onChange={handleChange}
            />
          </div>

          <div className="mb-3">
            <label htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              className="form-control"
              name="email"
              value={userData.email || ''}
              onChange={handleChange}
            />
          </div>

          <div className="mb-3">
            <label htmlFor="role">Роль</label>
            <select
              id="role"
              name="role"
              className="form-control"
              value={userData.role || ''}
              onChange={handleChange}
            >
              <option value="admin">Админ</option>
              <option value="user">Пользователь</option>
            </select>
          </div>

          <div className="mb-3">
            <label htmlFor="password">Пароль</label>
            <input
              id="password"
              type="password"
              className="form-control"
              name="password"
              value={userData.password || ''}
              onChange={handleChange}
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-secondary" onClick={onHide}>Отмена</button>
        <button className="btn btn-primary" onClick={onSave} disabled={loading}>Создать</button>
      </Modal.Footer>
    </Modal>
  );
};

export default AddUserModal;
